import { render, staticRenderFns } from "./otodetzyls.vue?vue&type=template&id=e0b4c256&scoped=true&"
import script from "./otodetzyls.vue?vue&type=script&lang=js&"
export * from "./otodetzyls.vue?vue&type=script&lang=js&"
import style0 from "./otodetzyls.vue?vue&type=style&index=0&id=e0b4c256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b4c256",
  null
  
)

export default component.exports